import type { FunctionalComponent } from 'preact';
import { useCallback, useState } from 'preact/hooks';

import { useScrollReachedEnd } from './block-sticky-banner-1.hooks/use-scroll-reached-end.js';
import type { BlockStickyBanner1Props } from './block-sticky-banner-1.js';
import { BlockStickyBanner1 } from './block-sticky-banner-1.js';

export type BlockStickyBanner1ContainerProps = Omit<BlockStickyBanner1Props, 'hidden' | 'onCloseButtonClick'>;

export const BlockStickyBanner1Container: FunctionalComponent<BlockStickyBanner1ContainerProps> = (props) => {
    const [closed, setClosed] = useState(false);
    const close = useCallback(() => setClosed(true), []);
    const reachedEnd = useScrollReachedEnd();

    return <BlockStickyBanner1 hidden={closed || reachedEnd} onCloseButtonClick={close} {...props} />;
};
